import { render } from "./PlaceDashboard.vue?vue&type=template&id=23ce8410&scoped=true"
import script from "./PlaceDashboard.vue?vue&type=script&lang=js"
export * from "./PlaceDashboard.vue?vue&type=script&lang=js"

import "./PlaceDashboard.vue?vue&type=style&index=0&id=23ce8410&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ce8410"]])

export default __exports__